import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { CommonService } from '../../../../shared/services/commom.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { ConsultarFuncionarioService } from './consultar-funcionario.service';

@Component({
  selector: 'ngx-consultar-funcionario',
  templateUrl: './consultar-funcionario.component.html',
  styleUrls: ['./consultar-funcionario.component.scss']
})
export class ConsultarFuncionarioComponent implements OnInit, OnDestroy {

  public formSearch = null;
  public rowData: any;
  public tableLimit = 10;

  @ViewChild('myTable', null)
  public table: DatatableComponent;
  public customLogin = null;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  constructor(

    private formBuilder: FormBuilder,
    private router: Router,
    private service: ConsultarFuncionarioService,
    private route: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private paginationService: SpringDatatablePaginationService,
    private datatableService: DatatableService,
    private spinnerService: NgxSpinnerService,
    private notifications: NotificationsService,
    ) 
    {
      this.rowData = [];
      this.paginationService.setDatatablePagination(this.datatablePagination);

     }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);
    this.formSearch = this.formBuilder.group({
      cpf: [null],
      nome: [null],
      matricula: [null]
    });

    this.fillEmployeeList();

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table)
  } 

  fillEmployeeList(data?: any, page?: string) {

    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit));

    if (page) {
      params = params.append('page', page);
    }

    if (data) {
      if (data.cpf != null) {
        params = params.append('cpf', data.cpf);
      }

      if (data.nome != null && String(data.nome).trim() !== '') {
        params = params.append('nome', data.nome);
      }

      if (data.matricula != null) {
        params = params.append('matricula', data.matricula);
      }
    }
    this.spinnerService.show();
    this.service.buscaFuncionarios(params, (response) => {

      if (response.content.length === 0) {

        this.spinnerService.hide();
        this.notifications.error('Não foi possível buscar funcionários.');
        this.datatablePagination.rowData = [null];
        this.datatablePagination.totalElements = 0;
        
      }else{
        this.paginationService.setInfo(response);
        this.spinnerService.hide();
      }
      
    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error('Não foi possível buscar funcionários.');
    });
  }

  gotoVisualizar(data) {

    let pessoaId: any = this.encriptyService.encriptyBySecretKey('' + data.pessoa.id);
    let pessoaCpf: any = this.encriptyService.encriptyBySecretKey('' + data.pessoa.cpf);
    let funcionarioId: any = this.encriptyService.encriptyBySecretKey('' + data.funcionario.id);
    let matricula: any = this.encriptyService.encriptyBySecretKey('' + data.funcionario.matricula);

    let params:any = {
      'pessoaId': pessoaId,
      'pessoaCpf': pessoaCpf,
      'funcionarioId': funcionarioId,
      'matricula': matricula,
      'isRegister': this.encriptyService.encriptyBySecretKey('N'),
    };

      this.router.navigate(['../visualizar-funcionario'], { relativeTo: this.route, queryParams: params});


  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
